import { usePoll } from "@inertiajs/react";
import PageHeader from "@/components/PageHeader";
import TabNavigation from "@/components/tabs/TabNavigation";
import Tag from "@/components/Tag";
import { Artwork } from "@/components/ArtworkSlot";
import buildTrackTabs from "../trackTabs";
import { withDisplayChrome } from "./contractChrome";
import { formatStatus, statusVariant } from "./contractStatus";
import ContractPdfLink from "./ContractPdfLink";

const PdfPoller: React.FC = () => {
  usePoll(2000, { only: ["contract"] });
  return null;
};

interface ContractShowProps {
  track: {
    id: number;
    title: string;
    artwork_attached: boolean;
  };
  artwork: Artwork;
  contract: {
    id: number;
    kind: string;
    title: string;
    status: string;
    document_url: string | null;
    pdf_generating: boolean;
  };
  rendered_html: string;
}

const Show: React.FC<ContractShowProps> = ({
  track,
  artwork,
  contract,
  rendered_html,
}) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      {contract.pdf_generating && <PdfPoller />}
      <PageHeader
        backLink={{
          href: `/tracks/${track.id}/contracts`,
          text: "Back to contracts",
        }}
        title={track.title}
        artwork={{
          trackId: track.id,
          uploaded: track.artwork_attached,
          thumbnailUrl: artwork.thumbnail_url,
          originalUrl: artwork.original_url,
          alt: `${track.title} artwork`,
        }}
      />
      <TabNavigation tabs={buildTrackTabs(track.id, "contracts")} />

      <div className="flex w-full flex-col gap-6">
        <div className="flex flex-row flex-wrap items-center gap-3">
          <h2 className="text-cream-900 dark:text-cream-100 text-lg font-semibold">
            {contract.title}
          </h2>
          <Tag
            label={formatStatus(contract.status)}
            variant={statusVariant(contract.status)}
          />
          <ContractPdfLink
            className="ml-auto"
            variant="primary"
            documentUrl={contract.document_url}
            pdfGenerating={contract.pdf_generating}
          />
        </div>

        <iframe
          srcDoc={withDisplayChrome(rendered_html)}
          title={contract.title}
          sandbox=""
          className="border-cream-200 dark:border-cream-800 h-[80vh] w-full rounded-2xl border bg-white"
        />
      </div>
    </div>
  );
};

export default Show;
